import { ERulerActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const disableRuler = actionGenerator<ERulerActionType.RulerDisabled>(ERulerActionType.RulerDisabled);
